import IcMinimize from './IcMinimize'

export default IcMinimize
